module.exports = __webpack_public_path__ + "static/img/tx_3.9bc28339.png";